
// Define the list names enum
export enum LIST_NAMES {
  FAVORITES = 'favorites',
  WATCHLIST = 'watchlist',
  UNSEEN_GEMS = 'unseen_gems'
}

// Export MovieListName type that's used throughout the app
export type MovieListName = LIST_NAMES;

// Define and export LIST_LABELS object that's imported by TabsNavigation
export const LIST_LABELS: Record<LIST_NAMES, string> = {
  [LIST_NAMES.FAVORITES]: 'Gems',
  [LIST_NAMES.WATCHLIST]: 'Watchlist',
  [LIST_NAMES.UNSEEN_GEMS]: 'Unseen gems'
};

// Field mapping for consistent camelCase usage
export const LIST_TO_FIELD_MAP: Record<LIST_NAMES, { resultFlag: string, field: string }> = {
  [LIST_NAMES.FAVORITES]: { 
    resultFlag: 'in_favorites', 
    field: 'favorite' 
  },
  [LIST_NAMES.WATCHLIST]: { 
    resultFlag: 'in_watchlist', 
    field: 'planToWatch'
  },
  [LIST_NAMES.UNSEEN_GEMS]: { 
    resultFlag: 'in_unseen', 
    field: 'favorite' 
  }
};

// Typed enum for single list operations using add_to_single_list and remove_from_single_list RPCs
export enum SINGLE_LIST_TYPE {
  FAVORITE = 'favorite',
  PLAN_TO_WATCH = 'plan_to_watch'
}

// Export the type for use in other files
export type SingleListType = SINGLE_LIST_TYPE;
